import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=b1af3bb8&scoped=true&"
import script from "./Message.vue?vue&type=script&lang=js&"
export * from "./Message.vue?vue&type=script&lang=js&"
import style0 from "./Message.vue?vue&type=style&index=0&id=b1af3bb8&prod&lang=less&scoped=true&"
import style1 from "./Message.vue?vue&type=style&index=1&id=b1af3bb8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1af3bb8",
  null
  
)

export default component.exports